<template>
	<PageTitleComponent>Resources</PageTitleComponent>

	<ResourcesFilterComponent />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageTitleComponent from '@/components/shared/PageTitleComponent.vue';
import ResourcesFilterComponent from './ResourcesFilterComponent.vue';

export default defineComponent({
	components: { PageTitleComponent, ResourcesFilterComponent },
});
</script>
